<template>
  <div class="app-container">
    <!-- <Top></Top> -->

    <!-- Banner区 - 全屏独占显示 -->
    <div class="banner" ref="banner">
      <div class="banner-bg-layer">
        <img src="https://images.unsplash.com/photo-1534796636912-3b95b3ab5986?q=80&w=2072&auto=format&fit=crop"
          alt="星空背景" class="banner-img" />
        <div class="banner-overlay"></div>
        <div class="nebula-effect"></div>
      </div>

      <div class="particles-container">
        <div class="particle" v-for="n in 30" :key="n" :style="getParticleStyle(n)"></div>
      </div>

      <!-- 新增：平台大标题 -->
      <div class="platform-title-wrapper">
        <div class="platform-badge">
          <i class="el-icon-cloud-check"></i>
          <span>官方认证平台</span>
        </div>
        <h1 class="platform-title">智步云上模型网</h1>
        <p class="platform-subtitle">Digital Twin Asset Marketplace</p>
        <div class="title-decoration">
          <span class="deco-line"></span>
          <i class="el-icon-star-on"></i>
          <span class="deco-line"></span>
        </div>
      </div>

      <div class="banner-search-wrapper">
        <div class="banner-search-box" :class="{ 'focused': isSearchFocused }">
          <i class="el-icon-search search-icon"></i>
          <input type="text" class="banner-search-input" placeholder="请搜索模型或分类" v-model="searchKey" @input="handleInput"
            @focus="handleFocus" @blur="handleBlur" @keyup.enter="handleSearch" />
          <button class="banner-search-btn" @click="handleSearch">
            <span>探索</span>
            <i class="el-icon-right"></i>
          </button>

          <div class="banner-search-dropdown" v-if="showDropdown && filteredResults.length">
            <div class="dropdown-item" v-for="(item, index) in filteredResults" :key="index"
              @click="handleSelectItem(item)" v-html="highlightMatch(item)">
            </div>
          </div>
        </div>
      </div>

      <div class="banner-desc">
        <div class="badge">DIGITAL TWIN ASSETS</div>
        <h3 class="main-title">数字孪生 3D 动态资产</h3>
        <p class="sub-title">驱动数字孪生，动态资产赋能精准决策</p>
        <div class="desc-stats">
          <div class="stat-item">
            <span class="stat-num">{{ modelNum }}</span>
            <span class="stat-label">精品模型</span>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <span class="stat-num">{{ designerNum }}</span>
            <span class="stat-label">认证模型师</span>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <span class="stat-num">100%</span>
            <span class="stat-label">好评率</span>
          </div>
        </div>
      </div>

      <div class="banner-bottom-fade"></div>
    </div>

    <!-- 热门模型区 -->
    <section class="models-section dynamic-bg" ref="modelsSection">
      <div class="bg-animation">
        <div class="grid-floor"></div>
        <div class="floating-lights">
          <div class="light" v-for="n in 8" :key="n" :style="{ '--i': n }"></div>
        </div>
        <div class="circuit-lines">
          <div class="line" v-for="n in 5" :key="'line-' + n"></div>
        </div>
      </div>

      <div class="container narrow">
        <div class="section-header split">
          <div class="title-group">
            <span class="section-label">Discover MODELS</span>
            <h2 class="section-title">推荐模型</h2>
          </div>

          <div class="title-tabs">
            <button class="tab-btn" :class="{ active: activeTitle === 'hot' }" @click="handleTitleChange('hot')">
              热门模型
            </button>
            <button class="tab-btn" :class="{ active: activeTitle === 'followed' }"
              @click="handleTitleChange('followed')" v-if="token">
              我的关注
            </button>
          </div>
        </div>

        <div class="quick-filters" ref="filterContainer">
          <span class="quick-tag" :class="{ active: activeTab === '全部' }" @click="changePopularModelAllKind()">
            全部
          </span>
          <span v-for="tag in visibleQuickTags" :key="tag.id" class="quick-tag"
            :class="{ active: activeTab === tag.name }" @click="changePopularModelKind(tag.name)">
            {{ tag.name }}
          </span>
          <span v-if="showMoreButton" class="quick-tag more-btn" :class="{ active: showAllTags }"
            @click="toggleShowAllTags">
            {{ showAllTags ? '收起' : '更多' }}
            <i :class="showAllTags ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </span>
        </div>

        <div class="models-grid">
          <div class="model-card" v-for="(model, index) in paginatedModelList" :key="model.id"
            @click="handleModelDetail(model.id)" :style="{ '--delay': index * 0.05 + 's' }">
            <div class="card-shimmer"></div>
            <div class="model-img-container">
              <img :src="model.img || 'https://via.placeholder.com/400x300/1e293b/38bdf8?text=3D+Model'"
                :alt="model.name" class="model-img" loading="lazy" />
              <div class="model-overlay">
                <div class="view-btn">
                  <i class="el-icon-view"></i>
                  <span>查看详情</span>
                </div>
              </div>
              <div class="model-badge exclusive" v-if="model.isExclusive">独家发售</div>
              <div class="model-badge format" v-if="model.format">{{ model.format }}</div>
              <div class="model-badge official" v-if="model.officialmod">
                <span>官方认证</span>
              </div>
              <div class="model-badge invoice" v-if="model.whetherInvoice">
                可开发票
              </div>
            </div>
            <div class="model-info">
              <h3 class="model-name">{{ model.name }}</h3>
              <div class="model-meta">
                <div class="price">
                  <span class="amount">{{ model.price }}</span>
                  <span class="unit">云币</span>
                </div>
                <div class="sales">
                  <!-- <i class="el-icon-sold-out"></i> -->
                  <i class="el-icon-view"></i>
                  <span>{{ formatNumber(model.views) }}</span>
                </div>
              </div>
            </div>
          </div>

          <div v-if="isLoading" v-for="n in 6" :key="'skeleton-' + n" class="model-card skeleton">
            <div class="skeleton-img"></div>
            <div class="skeleton-body">
              <div class="skeleton-line"></div>
              <div class="skeleton-line short"></div>
            </div>
          </div>
        </div>

        <div v-if="!isLoading && paginatedModelList.length === 0" class="no-data">
          <i class="el-icon-box"></i>
          <p>暂无相关模型</p>
        </div>

        <div class="load-more" v-if="!isLoading && showModelLoadMore">
          <button class="btn-outline" @click="loadMoreModels" :disabled="isLoadingMore">
            <span>{{ isLoadingMore ? '加载中...' : '加载更多' }}</span>
            <i class="el-icon-arrow-down" v-if="!isLoadingMore"></i>
          </button>
        </div>
      </div>
    </section>

    <!-- 新增：官方模型推荐模块 - 高级样式 -->
    <section class="official-models-section" ref="officialSection">
      <div class="official-bg-effects">
        <div class="gradient-orb orb-1"></div>
        <div class="gradient-orb orb-2"></div>
        <div class="gradient-orb orb-3"></div>
        <div class="mesh-grid"></div>
      </div>

      <div class="container narrow">
        <div class="section-header official-header">
          <div class="official-badge">
            <i class="el-icon-medal"></i>
            <span>OFFICIAL</span>
          </div>
          <h2 class="section-title">官方模型推荐</h2>
          <p class="section-desc">精选平台官方认证的高品质数字孪生资产</p>
        </div>

        <!-- 特色展示位 - 大图+详情 -->
        <div class="featured-official-model" v-if="displayedOfficialModels.length > 0">
          <div class="featured-card" @click="handleModelDetail(displayedOfficialModels[0].id)">
            <div class="featured-glow"></div>
            <div class="featured-image-wrap">
              <img
                :src="displayedOfficialModels[0].img || 'https://via.placeholder.com/800x500/1e293b/38bdf8?text=Official+Model'"
                :alt="displayedOfficialModels[0].name" class="featured-image" />
              <div class="featured-overlay">
                <div class="play-btn">
                  <i class="el-icon-caret-right"></i>
                  <span>预览模型</span>
                </div>
              </div>
              <div class="official-tag">
                <span>官方认证</span>
              </div>
            </div>
            <div class="featured-content">
              <div class="featured-header">
                <h3 class="featured-title">{{ officialModels[0].name }}</h3>
                <div class="featured-price">
                  <span class="price-num">{{ officialModels[0].price }}</span>
                  <span class="price-icon">云币</span>
                </div>
              </div>
              <p class="featured-desc">{{ officialModels[0].description || '经过严格质量检测的官方认证模型，确保精确度与可用性，适用于各类专业场景。' }}</p>
              <div class="featured-meta">
                <div class="meta-item">
                  <i class="el-icon-view"></i>
                  <span>{{ formatNumber(officialModels[0].views) }} 浏览</span>
                </div>
                <div class="meta-item">
                  <i class="el-icon-download"></i>
                  <span>{{ formatNumber(officialModels[0].downloads) }} 下载</span>
                </div>
                <!-- <div class="meta-item">
                  <i class="el-icon-star-on"></i>
                  <span>{{ officialModels[0].rating || '4.9' }} 评分</span>
                </div> -->
              </div>
              <div class="featured-tags">
                <span class="tag" v-for="(tag, idx) in (officialModels[0].tags || ['高精度', 'PBR材质', '官方认证'])" :key="idx">
                  {{ tag }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- 官方模型列表 - 横向高级卡片 -->
        <div class="official-models-list">
          <div class="official-model-card" v-for="(model, index) in displayedOfficialModels.slice(1)" :key="model.id"
            @click="handleModelDetail(model.id)" :style="{ '--delay': index * 0.1 + 's' }">
            <div class="card-glass-effect"></div>
            <div class="official-card-border"></div>
            <div class="card-image">
              <img :src="model.img" :alt="model.name" />
              <div class="image-shine"></div>
              <div class="official-stamp">
                <i class="el-icon-medal-1"></i>
              </div>
            </div>
            <div class="card-content">
              <h4 class="card-title">{{ model.name }}</h4>
              <div class="card-stats">
                <span class="stat"><i class="el-icon-view"></i> {{ formatNumber(model.views) }}</span>
                <span class="stat"><i class="el-icon-download"></i> {{ formatNumber(model.sales) }}</span>
              </div>
              <div class="card-footer">
                <span class="card-price">{{ model.price }}云币</span>
                <button class="card-action">
                  <span>查看</span>
                  <i class="el-icon-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="official-footer">
          <button class="btn-premium-outline" @click="loadMoreOfficialModels" :disabled="isLoadingOfficialMore"
            v-if="showOfficialLoadMore">
            <span>{{ isLoadingOfficialMore ? '加载中...' : '加载更多' }}</span>
            <i :class="isLoadingOfficialMore ? 'el-icon-loading' : 'el-icon-arrow-right'"></i>
          </button>
        </div>
      </div>
    </section>

    <!-- 模型师区 -->
    <section class="designers-section" ref="designerSection">
      <div class="section-bg-pattern"></div>
      <div class="diagonal-lines">
        <div class="d-line" v-for="n in 10" :key="'d-' + n"></div>
      </div>
      <div class="hexagon-pattern"></div>

      <div class="container narrow">
        <div class="section-header split">
          <div class="title-group">
            <span class="section-label">Discover DESIGNERS</span>
            <h2 class="section-title">推荐模型师</h2>
          </div>

          <div class="title-tabs">
            <button class="tab-btn" :class="{ active: activeDesignerTab === 'hot' }"
              @click="handleDesignerTabChange('hot')">
              热门模型师
            </button>
            <button class="tab-btn" :class="{ active: activeDesignerTab === 'followed' }"
              @click="handleDesignerTabChange('followed')" v-if="token">
              我的关注
            </button>
          </div>
        </div>

        <div class="designers-grid">
          <div class="designer-card" v-for="(designer, index) in paginatedDesignerList" :key="designer.userID"
            @click="goDesigner(designer.userID)" :style="{ '--delay': index * 0.08 + 's' }">
            <div class="card-bg"></div>
            <div class="card-border-glow"></div>
            <div class="designer-header">
              <div class="avatar-wrap">
                <div class="avatar-glow" :class="{ 'online': designer.isOnline }"></div>
                <img :src="designer.userAvatar || 'http://49.232.163.2:5159/image/30.png'" :alt="designer.userName"
                  class="avatar" />
                <div class="status-indicator" v-if="designer.isOnline">
                  <span class="pulse"></span>
                </div>
              </div>
              <div class="header-info">
                <h4 class="name">{{ designer.userName }}</h4>
                <p class="title">{{ designer.briefIntroduction || '资深3D模型师' }}</p>
              </div>
            </div>

            <div class="designer-stats">
              <div class="stat">
                <span class="num">{{ formatNumber(designer.clickThrough) }}</span>
                <span class="label">浏览</span>
              </div>
              <div class="stat">
                <span class="num">{{ formatNumber(designer.followers) }}</span>
                <span class="label">粉丝</span>
              </div>
              <div class="stat">
                <span class="num">{{ designer.publishVolume }}</span>
                <span class="label">作品</span>
              </div>
            </div>

            <button class="follow-btn" :class="{ followed: designer.follow }" @click.stop="handleFollowDesigner(index)">
              <div class="btn-bg"></div>
              <i :class="designer.follow ? 'el-icon-check' : 'el-icon-plus'"></i>
              <span>{{ designer.follow ? "已关注" : "关注" }}</span>
              <div class="btn-shine" v-if="!designer.follow"></div>
            </button>
          </div>

          <div v-if="designerLoading" v-for="n in 6" :key="'designer-skeleton-' + n" class="designer-card skeleton">
            <div class="skeleton-avatar"></div>
            <div class="skeleton-body">
              <div class="skeleton-line"></div>
              <div class="skeleton-line short"></div>
            </div>
          </div>
        </div>

        <div class="load-more" v-if="pagination.designer.current < originalDesignerList.length">
          <button class="btn-outline light" @click="loadMoreDesigners" :disabled="designerLoading">
            <span>{{ designerLoading ? '加载中...' : '查看更多模型师' }}</span>
          </button>
        </div>
      </div>
    </section>

    <!-- 分类区 - 螺旋分布防重叠气泡（已移动到模型师下方） -->
    <section class="category-cloud-section" ref="categorySection">
      <div class="section-bg-effects">
        <div class="glow-orb left"></div>
        <div class="glow-orb right"></div>
        <div class="floating-dots">
          <div class="dot" v-for="n in 20" :key="n" :style="getDotStyle(n)"></div>
        </div>
      </div>

      <div class="container narrow">
        <div class="section-header">
          <span class="section-label">CATEGORY</span>
          <h2 class="section-title">模型总览</h2>
        </div>

        <div class="category-cloud-container">
          <!-- 中央动态信息圆环 -->
          <div class="center-info-hub" :class="{ 'active': hoveredCategory }">
            <div class="hub-ring outer"></div>
            <div class="hub-ring inner"></div>
            <div class="hub-ring scan"></div>
            <div class="hub-glow"></div>
            <div class="hub-content">
              <div class="hub-number">{{ hoveredCategory ? hoveredCategory.count : totalModelsRaw }}</div>
              <div class="hub-label">{{ hoveredCategory ? hoveredCategory.name : '全部模型' }}</div>
            </div>
          </div>

          <!-- 螺旋分布的气泡 - 确保不重叠 -->
          <div class="category-bubble" v-for="(category, index) in filterList" :key="category.id" :class="{
            'active': hoveredCategory && hoveredCategory.id === category.id,
            'inner-layer': getBubbleLayer(index) === 0,
            'mid-layer': getBubbleLayer(index) === 1,
            'outer-layer': getBubbleLayer(index) === 2
          }" :style="getBubblePosition(index, category.name.length)" @mouseenter="handleBubbleEnter(category, index)"
            @mouseleave="handleBubbleLeave" @click="SearchTypeById(category.id)">
            <div class="bubble-bg">
              <div class="bubble-shine"></div>
            </div>
            <div class="bubble-content">
              <i :class="getCategoryIcon(index)"></i>
              <span class="bubble-name">{{ category.name }}</span>
              <span class="bubble-count">{{ category.count }} 模型</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 招募区 - 位于模型分类下方 -->
    <section class="recruit-section" ref="recruitSection">
      <div class="bg-effects">
        <div class="aurora-bg"></div>
        <div class="grid-overlay"></div>
        <div class="glow-orb left"></div>
        <div class="glow-orb right"></div>
      </div>

      <div class="container narrow">
        <div class="recruit-layout">
          <div class="recruit-main">
            <div class="recruit-header">
              <span class="recruit-label">JOIN US</span>
              <h2 class="recruit-title">
                诚邀模型师<br />
                <span class="highlight">加入我们</span>
              </h2>
            </div>

            <p class="recruit-desc">
              开启职业新征途，与众多创作者共建品牌<br />
              共享长期收益与行业影响力
            </p>

            <div class="benefits">
              <div class="benefit-item" v-for="(benefit, idx) in benefits" :key="idx">
                <div class="benefit-icon">
                  <i :class="benefit.icon"></i>
                </div>
                <div class="benefit-content">
                  <strong>{{ benefit.title }}</strong>
                  <span>{{ benefit.desc }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="recruit-action">
            <div class="action-card-premium">
              <div class="card-glow"></div>
              <div class="card-border"></div>
              <div class="card-content">
                <div class="icon-container">
                  <div class="icon-ring outer"></div>
                  <div class="icon-ring inner"></div>
                  <div class="icon-glow"></div>
                  <i class="el-icon-magic-stick main-icon"></i>
                </div>
                <h3 class="card-title">立即开启创作之旅</h3>
                <p class="card-subtitle">零门槛入驻，专业团队全程支持</p>
                <div class="feature-tags">
                  <span class="tag">高收益</span>
                  <span class="tag">版权保护</span>
                  <span class="tag">流量扶持</span>
                </div>
                <button class="btn-premium" @click="handleDesignerCertify">
                  <span>立即认证模型师</span>
                  <i class="el-icon-arrow-right"></i>
                  <div class="btn-glow"></div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <Bottom></Bottom> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
    Top: () => import('../../components/Header.vue'),
    Bottom: () => import('../../components/Footer.vue')
  },
  data() {
    return {
      modelNum: '',
      designerNum: '',
      searchKey: '',
      allResults: [],
      filteredResults: [],
      showDropdown: false,
      hoverIndex: -1,
      searchDebounce: null,
      isBlur: false,
      isSearchFocused: false,
      token: localStorage.getItem('token'),
      activeTitle: 'hot',
      activeDesignerTab: 'hot',
      activeTab: '全部',
      isLoading: false,
      isLoadingMore: false,
      designerLoading: false,
      hoveredCategory: null,
      totalModelsRaw: 0,

      filterList: [],
      visibleTagCount: 11,
      showAllTags: true,

      benefits: [
        { icon: 'el-icon-coin', title: '高收益', desc: '零门槛上传，让创作获得合理回报' },
        { icon: 'el-icon-first-aid-kit', title: '版权无忧', desc: '专业法务团队为原创保驾护航' },
        { icon: 'el-icon-s-custom', title: '高端客户', desc: '覆盖各行业头部企业合作机会' }
      ],

      pagination: {
        model: { limit: 6, loadMore: 6, current: 6 },
        designer: { limit: 6, loadMore: 6, current: 6 }
      },

      hotModelsFromApi: [],
      followedModelsFromApi: [],
      hotDesignersFromApi: [],
      followedDesignersFromApi: [],
      recommendDesigners: [],
      hotModels: [],
      followedModels: [],

      // 新增：官方模型数据
      officialModels: [],
      officialPagination: {
        limit: 8,
        current: 8,
        total: 0
      },
      isLoadingOfficialMore: false,
      iconMap: [
        'el-icon-office-building', 'el-icon-user', 'el-icon-truck',
        'el-icon-s-cooperation', 'el-icon-grape', 'el-icon-cpu',
        'el-icon-mouse', 'el-icon-shopping-bag-1', 'el-icon-video-camera',
        'el-icon-picture', 'el-icon-map-location', 'el-icon-sunny',
        'el-icon-first-aid-kit', 'el-icon-s-opportunity', 'el-icon-s-tools'
      ],

      containerWidth: 0,
      containerHeight: 0,
      bubblePositions: {}
    };
  },

  computed: {
    displayedOfficialModels() {
      // 第一个是特色推荐位，始终显示；其余按分页显示
      if (this.officialModels.length === 0) return [];
      const featured = this.officialModels[0];
      const others = this.officialModels.slice(1);
      const paginatedOthers = others.slice(0, this.officialPagination.current);
      return [featured, ...paginatedOthers];
    },
    // 是否显示加载更多按钮（普通推荐位还有更多时显示）
    showOfficialLoadMore() {
      if (this.officialModels.length <= 1) return false;
      const others = this.officialModels.slice(1);
      return this.officialPagination.current < others.length;
    },
    originalModelList() {
      const baseList = this.activeTitle === 'hot'
        ? (this.hotModelsFromApi.length ? this.hotModelsFromApi : this.hotModels)
        : (this.followedModelsFromApi.length ? this.followedModelsFromApi : this.followedModels);
      return baseList;
    },
    paginatedModelList() {
      return this.originalModelList.slice(0, this.pagination.model.current);
    },
    originalDesignerList() {
      return this.activeDesignerTab === 'hot'
        ? (this.hotDesignersFromApi.length ? this.hotDesignersFromApi : this.recommendDesigners)
        : (this.followedDesignersFromApi.length ? this.followedDesignersFromApi : this.recommendDesigners);
    },
    paginatedDesignerList() {
      return this.originalDesignerList.slice(0, this.pagination.designer.current);
    },
    showModelLoadMore() {
      return this.pagination.model.current < this.originalModelList.length;
    },
    showDesignerLoadMore() {
      return this.pagination.designer.current < this.originalDesignerList.length;
    },
    visibleQuickTags() {
      if (this.showAllTags) {
        return this.filterList;
      }
      return this.filterList.slice(0, this.visibleTagCount);
    },
    showMoreButton() {
      return this.filterList.length > this.visibleTagCount;
    }
  },

  created() {
    this.getModelCombing()//获取模型数量和模型师数量
    this.getFilterList();
    this.fetchModels();
    this.getPopularModelers();
    this.fetchOfficialModels(); // 新增：获取官方模型
  },

  mounted() {
    this.initEffects();
    this.updateContainerSize();
    window.addEventListener('resize', this.handleResize);
    this.calculateVisibleTagCount();

    if (localStorage.getItem('token')) {
      this.$nextTick(() => {
        // 若 Header 已挂载，调用其 getUserInt 方法
        const headerInstance = this.$root.$children.find(child => child.$options.name === 'Top');
        if (headerInstance) {
          headerInstance.getUserInt();
        }
      });
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    async loadMoreOfficialModels() {
      if (this.isLoadingOfficialMore) return;
      this.isLoadingOfficialMore = true;

      setTimeout(() => {
        const newCount = this.officialPagination.current + 8;  // 原来是+6，改为+8
        const others = this.officialModels.slice(1);
        this.officialPagination.current = Math.min(newCount, others.length);
        this.isLoadingOfficialMore = false;
      }, 600);
    },
    changePopularModelAllKind() {
      this.activeTab = "全部"
      // 重置模型分页到初始状态
      this.pagination.model.current = this.pagination.model.limit;
      this.isLoading = true; // 显示加载状态
      this.fetchModels();
    },
    changePopularModelKind(item) {
      this.activeTab = item
      // 重置模型分页到初始状态
      this.pagination.model.current = this.pagination.model.limit;
      this.isLoading = true; // 显示加载状态
      this.fetchModels();
    },
    async getModelCombing() {
      await this.$apiFun.getModelCombing()
        .then(res => {
          if (res.status === 200) {
            this.modelNum = res.obj.modelQ
            this.designerNum = res.obj.modelerQ
          }
        })
        .catch(err => console.error('获取模型数量/模型师数量失败:', err));
    },
    updateContainerSize() {
      const container = document.querySelector('.category-cloud-container');
      if (container) {
        this.containerWidth = container.offsetWidth;
        this.containerHeight = container.offsetHeight;
      }
    },

    handleResize() {
      this.updateContainerSize();
      this.calculateVisibleTagCount();
      this.bubblePositions = {}; // 重置位置缓存，重新计算
      this.$nextTick(() => {
        this.getBubblePosition.cache = {};
      });
    },

    calculateVisibleTagCount() {
      // const containerWidth = window.innerWidth > 1200 ? 1200 : window.innerWidth - 64;
      // const availableWidth = containerWidth - 200;
      // const count = Math.floor(availableWidth / 100);
      // this.visibleTagCount = Math.max(3, Math.min(count, 10));
      if (this.showAllTags) {
        this.visibleTagCount = this.filterList.length;
      } else {
        this.visibleTagCount = 11; // 默认显示11个
      }
    },

    toggleShowAllTags() {
      this.showAllTags = !this.showAllTags;
      this.calculateVisibleTagCount();
    },

    // 获取气泡层级（0=内层，1=中层，2=外层）
    getBubbleLayer(index) {
      const total = this.filterList.length;
      // 将气泡分为3层，内层6个，中层8个，其余外层
      if (index < 6) return 0;
      if (index < 14) return 1;
      return 2;
    },

    /**
     * 螺旋分布算法 - 确保气泡不重叠
     * 使用黄金角 137.5° (2.4弧度) 进行螺旋分布
     */
    getBubblePosition(index, textLength = 4) {
      // 如果已经缓存了位置，直接返回
      if (this.bubblePositions[index]) {
        return this.bubblePositions[index];
      }

      const total = this.filterList.length;
      if (total === 0) return {};

      if (this.containerWidth === 0) this.updateContainerSize();

      const centerX = this.containerWidth / 2 || 450;
      const centerY = this.containerHeight / 2 || 400;

      // 黄金角 137.5度（约2.4弧度），确保均匀分布
      const goldenAngle = 2.39996;

      const layer = this.getBubbleLayer(index);

      // 根据层级设置基础半径和间距
      let baseRadius, radiusStep;
      if (layer === 0) {
        baseRadius = 200; // 内层靠近中心
        radiusStep = 5;
      } else if (layer === 1) {
        baseRadius = 260; // 中层
        radiusStep = 15;
      } else {
        baseRadius = 320; // 外层远离中心
        radiusStep = 25;
      }

      // 螺旋分布计算：角度 = 索引 * 黄金角，半径 = 基础半径 + 索引 * 步长
      const angle = index * goldenAngle;
      const radius = baseRadius + (index * radiusStep * 0.3); // 稍微拉开距离

      // 转换为笛卡尔坐标，添加一些随机扰动避免过于规律
      const x = centerX + radius * Math.cos(angle);
      const y = centerY + radius * Math.sin(angle) * 0.8; // 压缩Y轴使分布更椭圆

      // 根据文字长度调整气泡大小
      const baseSize = 110;
      const sizeIncrement = Math.max(0, (textLength - 4) * 12);
      const bubbleSize = Math.min(baseSize + sizeIncrement, 150); // 最大限制150px

      // 生成独特的漂移参数
      const floatDuration = 8 + (index % 4) * 2; // 8-14秒周期
      const floatDelay = (index * 0.5) % 5; // 错开启动时间
      const driftRange = 10 + (index % 3) * 8; // 漂移范围10-26px

      const position = {
        left: `${x}px`,
        top: `${y}px`,
        width: `${bubbleSize}px`,
        height: `${bubbleSize}px`,
        marginLeft: `-${bubbleSize / 2}px`,
        marginTop: `-${bubbleSize / 2}px`,
        '--float-duration': `${floatDuration}s`,
        '--float-delay': `${floatDelay}s`,
        '--drift-range': `${driftRange}px`,
        '--drift-range-x': `${driftRange * 0.6}px`,
        zIndex: 60 - layer * 15 + (index % 10)
      };

      this.$set(this.bubblePositions, index, position);
      return position;
    },

    getDotStyle(n) {
      const seed = n * 9301 + 49297;
      return {
        left: `${10 + (seed % 8000) / 100}%`,
        top: `${10 + ((seed * 13) % 8000) / 100}%`,
        animationDelay: `${(seed % 5000) / 1000}s`,
        animationDuration: `${4 + (seed % 4000) / 1000}s`,
        width: `${2 + (seed % 300) / 100}px`,
        height: `${2 + (seed % 300) / 100}px`
      };
    },

    handleBubbleEnter(category, index) {
      this.hoveredCategory = { ...category, index };
    },

    handleBubbleLeave() {
      this.hoveredCategory = null;
    },

    getCategoryIcon(index) {
      return this.iconMap[index % this.iconMap.length];
    },

    formatNumber(num) {
      if (!num) return '0';
      const n = parseInt(num);
      if (isNaN(n)) return '0';

      if (n < 1000) {
        return n.toString();
      } else if (n < 10000) {
        return (n / 1000).toFixed(1) + 'k';
      } else {
        return (n / 10000).toFixed(1) + 'w';
      }
    },

    handleInput() {
      clearTimeout(this.searchDebounce);
      if (!this.searchKey.trim()) {
        this.allResults = [];
        this.filteredResults = [];
        this.showDropdown = false;
        return;
      }
      this.searchDebounce = setTimeout(() => this.fetchFuzzySearch(), 300);
    },

    fetchFuzzySearch() {
      this.$apiFun.getHomePageSearch({ title: this.searchKey })
        .then(res => {
          if (res.status === 200) {
            this.allResults = res.obj.map(item => item.title).slice(0, 10);
            this.filteredResults = [...this.allResults];
            this.showDropdown = true;
          }
        })
        .catch(err => console.error('搜索失败:', err));
    },

    highlightMatch(text) {
      if (!this.searchKey || !text || typeof text !== 'string') return text;

      // 转义正则特殊字符，避免输入 []() 等字符时报错
      const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const keyword = escapeRegExp(this.searchKey.trim());

      // 如果关键词为空，直接返回原文本
      if (!keyword) return text;

      const regex = new RegExp(`(${keyword})`, 'gi');
      return text.replace(regex, '<span class="search-highlight">$1</span>');
    },

    handleFocus() {
      this.isBlur = false;
      this.isSearchFocused = true;
      if (this.searchKey.trim() && this.allResults.length > 0) {
        this.showDropdown = true;
      }
    },

    handleBlur() {
      this.isBlur = true;
      this.isSearchFocused = false;
      setTimeout(() => { if (this.isBlur) this.showDropdown = false; }, 200);
    },

    handleSelectItem(item) {
      this.searchKey = item;
      this.showDropdown = false;
      this.handleSearch();
    },

    handleSearch() {
      const keyword = this.searchKey.trim();
      if (!keyword) {
        this.$message.warning('请输入搜索关键词');
        return;
      }
      const routeInfo = this.$router.resolve({ path: '/search', query: { title: keyword } });
      window.open(routeInfo.href, '_blank');
    },

    getParticleStyle(n) {
      const seed = n * 9301 + 49297;
      return {
        left: `${(seed % 10000) / 100}%`,
        top: `${((seed * 17) % 10000) / 100}%`,
        animationDelay: `${(seed % 5000) / 1000}s`,
        animationDuration: `${(seed % 10000) / 1000 + 10}s`
      };
    },

    initEffects() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      }, { threshold: 0.1 });

      [this.$refs.categorySection, this.$refs.modelsSection, this.$refs.designerSection, this.$refs.recruitSection, this.$refs.officialSection]
        .filter(Boolean).forEach(el => observer.observe(el));
    },

    SearchTypeById(id) {
      const category = this.filterList.find(c => c.id === id);
      if (!category) return;
      const routeInfo = this.$router.resolve({ path: '/type', query: { type: category.name } });
      window.open(routeInfo.href, '_blank');
    },

    mapApiDataToLocal(apiItem) {
      return {
        id: apiItem.modelId,
        name: apiItem.title,
        img: apiItem.previewUrl,
        price: apiItem.licensingPrices,
        sales: apiItem.salesVolume,
        views: apiItem.clickThrough,
        officialmod: apiItem.officialmod || false,  // 新增：官方认证标记
        // category: "all",
        // isExclusive: apiItem.isExclusive || false,
        // format: apiItem.format || 'FBX'
        whetherInvoice: apiItem.whetherInvoice || false
      };
    },

    async getFilterList() {
      await this.$apiFun.getOneType()
        .then(res => {
          if (res.status === 200) {
            this.filterList = res.obj.map((item, idx) => ({
              id: item.oneId,
              name: item.oneName,
              count: item.quantity
            }));
            this.totalModelsRaw = this.filterList.reduce((sum, item) => sum + item.count, 0);
            this.$nextTick(() => {
              this.updateContainerSize();
              this.calculateVisibleTagCount();
            });
          }
        })
        .catch(err => console.error('获取分类失败:', err));
    },

    async fetchModels() {
      this.isLoading = true;
      try {
        if (this.activeTitle === 'hot') {
          const res = await this.$apiFun.getRecommendedPopular({ onetype: this.activeTab });
          if (res.status === 200) {
            this.hotModelsFromApi = res.obj.map(item => this.mapApiDataToLocal(item));
          }
        } else {
          const res = await this.$apiFun.getBuyerCenterMyInterest({ onetype: this.activeTab });
          if (res.status === 200) {
            this.followedModelsFromApi = res.obj.map(item => this.mapApiDataToLocal(item));
          }
        }
      } catch (err) {
        console.error('加载失败:', err);
      } finally {
        this.isLoading = false;
      }
    },

    // 新增：获取官方模型数据
    async fetchOfficialModels() {
      try {
        // 获取特别推荐位（横板大图，只有一个）
        const featuredRes = await this.$apiFun.getOfficialModel();
        let featuredModel = null;
        if (featuredRes.status === 200 && featuredRes.obj && featuredRes.obj.length > 0) {
          const item = featuredRes.obj[0];
          featuredModel = {
            id: item.modelId,
            name: item.title,
            img: item.previewUrl,
            price: item.licensingPrices,
            description: item.instructions || '经过严格质量检测的官方认证模型，确保精确度与可用性，适用于各类专业场景。',
            views: item.clickThrough,
            downloads: item.salesVolume,
            // rating: '5.0', // 特别推荐位默认5.0分
            tags: item.modeltype || ['官方认证', '高品质', '推荐']
          };
        }

        // 获取普通推荐位（小图列表，多个）
        const listRes = await this.$apiFun.getOfficialModeler();
        let normalModels = [];
        if (listRes.status === 200 && listRes.obj) {
          normalModels = listRes.obj.map(item => ({
            id: item.modelId,
            name: item.title,
            img: item.previewUrl,
            price: item.licensingPrices,
            // rating: '4.8', // 普通推荐位默认评分
            sales: item.salesVolume,
            views: item.clickThrough
          }));
        }

        // 合并数据：特别推荐位放在首位，后面跟普通推荐位
        this.officialModels = featuredModel ? [featuredModel, ...normalModels] : normalModels;

        // 初始化官方模型分页
        this.officialPagination = {
          limit: 8,
          current: 8,
          total: this.officialModels.length
        };
      } catch (err) {
        console.error('获取官方模型失败:', err);
        this.$message.error('加载官方推荐失败');
      }
    },

    // 新增：跳转到官方模型页面
    goToOfficialPage() {
      const routeInfo = this.$router.resolve({ path: '/official-models' });
      window.open(routeInfo.href, '_blank');
    },

    async getPopularModelers() {
      try {
        const res = await this.$apiFun.getPopularModelers();
        if (res.status === 200) {
          this.hotDesignersFromApi = res.obj.map(designer => ({
            ...designer,
            views: designer.clickThrough,
            followers: designer.followers,
            works: designer.publishVolume,
            isOnline: Math.random() > 0.5
          }));
          this.recommendDesigners = this.hotDesignersFromApi;
        }
      } catch (err) {
        console.error('获取模型师失败:', err);
        // this.recommendDesigners = this.generateFakeDesigners();
      }
    },
    async getFollowedDesigners() {
      try {
        const res = await this.$apiFun.getHomePageMyInterest();
        if (res.status === 200) {
          this.followedDesignersFromApi = res.obj.map(designer => ({
            ...designer,
            views: designer.clickThrough,
            followers: designer.followers,
            works: designer.publishVolume,
            isOnline: Math.random() > 0.5
          }));
          this.recommendDesigners = this.followedDesignersFromApi;
        }
      } catch (err) {
        console.error('获取模型师失败:', err);
        // this.recommendDesigners = this.generateFakeDesigners();
      }
    },
    generateFakeDesigners() {
      const names = ['张建模', '李3D', '王设计师', '陈渲染', '刘视觉', '赵数字', '孙创意', '周艺术'];
      return names.map((name, index) => ({
        userID: index + 1,
        userName: name,
        userAvatar: 'http://49.232.163.2:5159/image/30.png',
        briefIntroduction: '资深3D模型师，专注数字孪生',
        views: Math.floor(Math.random() * 50000) + 1000,
        followers: Math.floor(Math.random() * 5000) + 100,
        works: Math.floor(Math.random() * 50) + 5,
        follow: false,
        isOnline: Math.random() > 0.5
      }));
    },

    handleTitleChange(type) {
      this.activeTitle = type;
      this.activeTab = '全部';
      this.pagination.model.current = this.pagination.model.limit;
      this.fetchModels();
    },

    handleDesignerTabChange(type) {
      // this.activeDesignerTab = type;
      // this.pagination.designer.current = this.pagination.designer.limit;
      // this.getPopularModelers();

      this.activeDesignerTab = type;
      this.pagination.designer.current = this.pagination.designer.limit;
      if (type === 'hot') {
        this.getPopularModelers();
      } else if (type === 'followed') {
        this.getFollowedDesigners();
      }
    },

    goToDetail(modelId) {
      const routeInfo = this.$router.resolve({ path: '/detail', query: { id: modelId } });
      window.open(routeInfo.href, '_blank');
    },

    goDesigner(designerId) {
      const routeInfo = this.$router.resolve({ path: '/designer', query: { id: designerId } });
      window.open(routeInfo.href, '_blank');
    },

    handleModelDetail(modelId) {
      this.goToDetail(modelId);
    },

    loadMoreModels() {
      if (this.isLoadingMore) return;
      this.isLoadingMore = true;
      setTimeout(() => {
        const newCount = this.pagination.model.current + this.pagination.model.loadMore;
        this.pagination.model.current = Math.min(newCount, this.originalModelList.length);
        this.isLoadingMore = false;
      }, 600);
    },

    loadMoreDesigners() {
      if (this.designerLoading) return;

      this.designerLoading = true;

      setTimeout(() => {
        const newCount = this.pagination.designer.current + this.pagination.designer.loadMore;
        // 每次点击加载6个，若最后一次不足6个则加载剩余的全部
        this.pagination.designer.current = Math.min(newCount, this.originalDesignerList.length);
        this.designerLoading = false;
      }, 500);
    },

    async handleFollowDesigner(index) {
      if (!this.token) {
        this.$message.warning('请先登录');
        this.$router.push('/login');
        return;
      }
      const designer = this.paginatedDesignerList[index];
      const isFollow = !designer.follow;
      designer.follow = isFollow;

      try {
        const res = await this.$apiFun.getAddMyInterest({ followedUser: designer.userID });
        if (res.status !== 200) {
          designer.follow = !isFollow;
          this.$message.error('操作失败');
        }
      } catch (err) {
        designer.follow = !isFollow;
        this.$message.error('网络异常');
      }
    },

    handleDesignerCertify() {
      if (this.token) {
        this.$router.push('/dashboard/seller/info');
      } else {
        this.$message.warning('请先登录');
        this.$router.push('/login');
      }
    }
  }
};
</script>

<style lang="less" scoped>
@bg-primary: #0a0e17;
@bg-secondary: #111827;
@bg-tertiary: #1f2937;
@accent-cyan: #06b6d4;
@accent-blue: #3b82f6;
@accent-light: #67e8f9;
@accent-indigo: #6366f1;
@accent-gold: #f59e0b;
@text-primary: #f9fafb;
@text-secondary: #9ca3af;
@text-muted: #6b7280;
@border-color: rgba(255, 255, 255, 0.08);

.container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;

  &.narrow {
    max-width: 1200px;
    padding: 0 32px;
  }
}

// ========== Banner区 - 添加平台大标题 ==========
.banner {
  width: 100%;
  height: calc(100vh - 60px);
  min-height: 800px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: @bg-primary;

  .banner-bg-layer {
    position: absolute;
    inset: 0;
    z-index: 0;

    .banner-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0.7;
    }

    .banner-overlay {
      position: absolute;
      inset: 0;
      background: radial-gradient(ellipse at center, transparent 0%, @bg-primary 70%);
      z-index: 1;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 200px;
      background: linear-gradient(to bottom, transparent, @bg-primary);
      z-index: 2;
    }

    .nebula-effect {
      position: absolute;
      top: 20%;
      left: 10%;
      width: 600px;
      height: 600px;
      background: radial-gradient(circle, rgba(6, 182, 212, 0.15) 0%, transparent 70%);
      filter: blur(60px);
      animation: nebula-float 20s ease-in-out infinite;
      z-index: 0;
    }
  }

  @keyframes nebula-float {

    0%,
    100% {
      transform: translate(0, 0) scale(1);
    }

    50% {
      transform: translate(30px, -30px) scale(1.1);
    }
  }

  .particles-container {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 1;

    .particle {
      position: absolute;
      width: 2px;
      height: 2px;
      background: @accent-cyan;
      border-radius: 50%;
      box-shadow: 0 0 6px @accent-cyan;
      animation: float-up 15s linear infinite;
      opacity: 0;
    }
  }

  @keyframes float-up {
    0% {
      transform: translateY(100vh) scale(0);
      opacity: 0;
    }

    10% {
      opacity: 0.8;
    }

    90% {
      opacity: 0.8;
    }

    100% {
      transform: translateY(-10vh) scale(1);
      opacity: 0;
    }
  }

  .banner-bottom-fade {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 150px;
    background: linear-gradient(to bottom, transparent, @bg-primary);
    z-index: 5;
    pointer-events: none;
  }
}

// 新增：平台大标题样式
.platform-title-wrapper {
  position: relative;
  z-index: 10;
  text-align: center;
  margin-bottom: 40px;
  animation: fade-in-down 1s ease-out;

  @keyframes fade-in-down {
    from {
      opacity: 0;
      transform: translateY(-30px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .platform-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 20px;
    background: rgba(6, 182, 212, 0.1);
    border: 1px solid rgba(6, 182, 212, 0.3);
    border-radius: 50px;
    color: @accent-cyan;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 2px;
    margin-bottom: 24px;
    backdrop-filter: blur(10px);

    i {
      font-size: 16px;
      color: @accent-gold;
    }
  }

  .platform-title {
    font-size: 56px;
    font-weight: 800;
    color: #fff;
    letter-spacing: 4px;
    margin-bottom: 16px;
    text-shadow: 0 0 40px rgba(6, 182, 212, 0.5);
    background: linear-gradient(to right, #fff, @accent-light, #fff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-size: 200% auto;
    animation: shine 3s linear infinite;
  }

  @keyframes shine {
    to {
      background-position: 200% center;
    }
  }

  .platform-subtitle {
    font-size: 18px;
    color: @text-secondary;
    letter-spacing: 8px;
    text-transform: uppercase;
    margin-bottom: 24px;
  }

  .title-decoration {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    color: @accent-cyan;
    opacity: 0.6;

    .deco-line {
      width: 60px;
      height: 1px;
      background: linear-gradient(to right, transparent, @accent-cyan, transparent);
    }

    i {
      font-size: 12px;
      animation: pulse 2s ease-in-out infinite;
    }
  }

  @keyframes pulse {

    0%,
    100% {
      opacity: 0.6;
      transform: scale(1);
    }

    50% {
      opacity: 1;
      transform: scale(1.2);
    }
  }
}

.banner-search-wrapper {
  position: relative;
  z-index: 10;
  width: 90%;
  max-width: 640px;
  margin-bottom: 60px;

  .banner-search-box {
    display: flex;
    align-items: center;
    background: rgba(17, 24, 39, 0.8);
    border: 1px solid @border-color;
    border-radius: 50px;
    height: 64px;
    padding: 0 6px 0 24px;
    backdrop-filter: blur(20px);
    transition: all 0.3s;

    &.focused {
      border-color: @accent-cyan;
      box-shadow: 0 0 0 3px rgba(6, 182, 212, 0.1), 0 0 30px rgba(6, 182, 212, 0.2);
    }

    .search-icon {
      color: @text-muted;
      margin-right: 16px;
      font-size: 20px;
    }

    .banner-search-input {
      flex: 1;
      background: transparent;
      border: none;
      outline: none;
      color: @text-primary;
      font-size: 16px;

      &::placeholder {
        color: @text-muted;
      }
    }

    .banner-search-btn {
      height: 52px;
      padding: 0 28px;
      background: linear-gradient(135deg, @accent-cyan, @accent-blue);
      border: none;
      border-radius: 50px;
      color: #fff;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      transition: all 0.3s;

      &:hover {
        transform: scale(1.05);
        box-shadow: 0 10px 30px rgba(6, 182, 212, 0.4);
      }
    }
  }
}

.banner-search-dropdown {
  position: absolute;
  top: calc(100% + 12px);
  left: 0;
  right: 0;
  background: rgba(17, 24, 39, 0.95);
  border: 1px solid @border-color;
  border-radius: 16px;
  overflow: hidden;
  backdrop-filter: blur(20px);
  z-index: 1000;

  .dropdown-item {
    padding: 14px 24px;
    color: @text-secondary;
    cursor: pointer;
    transition: all 0.2s;
    border-bottom: 1px solid @border-color;
    font-size: 14px;

    &:hover {
      background: rgba(6, 182, 212, 0.1);
      color: @text-primary;
      padding-left: 28px;
    }

    // 搜索高亮样式 - 荧光蓝
    .search-highlight {
      color: #67e8f9 !important; // 荧光青色
      font-weight: 700;
      background: rgba(6, 182, 212, 0.2);
      padding: 2px 6px;
      border-radius: 4px;
      text-shadow: 0 0 10px rgba(103, 232, 249, 0.8),
        0 0 20px rgba(6, 182, 212, 0.4);
      box-shadow: 0 0 8px rgba(6, 182, 212, 0.3);
      margin: 0 2px;
    }
  }

  .dropdown-item:last-child {
    border-bottom: none;
  }
}

.banner-desc {
  text-align: center;
  color: @text-primary;
  position: relative;

  .badge {
    display: inline-block;
    padding: 6px 16px;
    background: rgba(6, 182, 212, 0.1);
    border: 1px solid rgba(6, 182, 212, 0.3);
    border-radius: 20px;
    color: @accent-cyan;
    font-size: 12px;
    letter-spacing: 2px;
    margin-bottom: 24px;
    font-weight: 600;
  }

  .main-title {
    font-size: 52px;
    font-weight: 800;
    margin-bottom: 16px;
    letter-spacing: -1px;
    background: linear-gradient(to right, #fff, @accent-cyan);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .sub-title {
    font-size: 18px;
    color: @text-secondary;
    margin-bottom: 40px;
  }

  .desc-stats {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 48px;

    .stat-item {
      text-align: center;
    }

    .stat-num {
      display: block;
      font-size: 32px;
      font-weight: 700;
      color: @accent-cyan;
      margin-bottom: 4px;
    }

    .stat-label {
      font-size: 13px;
      color: @text-muted;
      text-transform: uppercase;
      letter-spacing: 1px;
    }

    .stat-divider {
      width: 1px;
      height: 40px;
      background: linear-gradient(to bottom, transparent, @border-color, transparent);
    }
  }
}

// ========== 热门模型区（样式保持不变） ==========
.models-section {
  background: linear-gradient(180deg, #0d1117 0%, #161b22 100%);
  padding: 100px 0;
  position: relative;
  overflow: hidden;

  &.dynamic-bg {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 1px;
      background: linear-gradient(to right, transparent, rgba(6, 182, 212, 0.5), transparent);
    }

    .bg-animation {
      position: absolute;
      inset: 0;
      overflow: hidden;
      pointer-events: none;

      .grid-floor {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 60%;
        background-image:
          linear-gradient(rgba(6, 182, 212, 0.05) 1px, transparent 1px),
          linear-gradient(90deg, rgba(6, 182, 212, 0.05) 1px, transparent 1px);
        background-size: 60px 60px;
        transform: perspective(600px) rotateX(60deg);
        transform-origin: bottom;
        animation: grid-move 20s linear infinite;
        mask-image: linear-gradient(to top, rgba(0, 0, 0, 0.4), transparent);
      }

      @keyframes grid-move {
        0% {
          transform: perspective(600px) rotateX(60deg) translateY(0);
        }

        100% {
          transform: perspective(600px) rotateX(60deg) translateY(60px);
        }
      }

      .floating-lights {
        position: absolute;
        inset: 0;

        .light {
          position: absolute;
          width: 4px;
          height: 4px;
          background: @accent-cyan;
          border-radius: 50%;
          box-shadow: 0 0 20px @accent-cyan, 0 0 40px @accent-cyan;
          opacity: 0;
          animation: light-float 6s ease-in-out infinite;
          animation-delay: calc(var(--i) * 1s);

          &:nth-child(1) {
            left: 10%;
            top: 20%;
          }

          &:nth-child(2) {
            left: 25%;
            top: 60%;
          }

          &:nth-child(3) {
            left: 50%;
            top: 30%;
          }

          &:nth-child(4) {
            left: 75%;
            top: 70%;
          }

          &:nth-child(5) {
            left: 85%;
            top: 40%;
          }

          &:nth-child(6) {
            left: 60%;
            top: 80%;
          }

          &:nth-child(7) {
            left: 15%;
            top: 45%;
          }

          &:nth-child(8) {
            left: 90%;
            top: 65%;
          }
        }
      }

      @keyframes light-float {

        0%,
        100% {
          opacity: 0;
          transform: translateY(0) scale(0);
        }

        50% {
          opacity: 0.8;
          transform: translateY(-120px) scale(1);
        }
      }

      .circuit-lines {
        position: absolute;
        inset: 0;
        opacity: 0.1;

        .line {
          position: absolute;
          background: linear-gradient(90deg, transparent, @accent-cyan, transparent);
          height: 1px;
          width: 200px;
          animation: circuit-flow 8s linear infinite;

          &:nth-child(1) {
            top: 20%;
            left: -200px;
            animation-delay: 0s;
          }

          &:nth-child(2) {
            top: 40%;
            left: -200px;
            animation-delay: 2s;
            width: 300px;
          }

          &:nth-child(3) {
            top: 60%;
            left: -200px;
            animation-delay: 4s;
          }

          &:nth-child(4) {
            top: 80%;
            left: -200px;
            animation-delay: 1s;
            width: 250px;
          }

          &:nth-child(5) {
            top: 30%;
            right: -200px;
            animation-delay: 3s;
            animation-direction: reverse;
          }
        }
      }

      @keyframes circuit-flow {
        0% {
          transform: translateX(0);
        }

        100% {
          transform: translateX(calc(100vw + 400px));
        }
      }
    }
  }

  .quick-filters {
    display: flex;
    gap: 10px;
    margin-bottom: 40px;
    flex-wrap: wrap;
    align-items: center;

    .quick-tag {
      padding: 8px 16px;
      background: rgba(255, 255, 255, 0.03);
      border: 1px solid @border-color;
      border-radius: 20px;
      color: @text-secondary;
      font-size: 13px;
      cursor: pointer;
      transition: all 0.2s;
      white-space: nowrap;

      &:hover,
      &.active {
        background: rgba(6, 182, 212, 0.1);
        border-color: @accent-cyan;
        color: @accent-cyan;
      }

      &.more-btn {
        background: rgba(6, 182, 212, 0.05);
        border-color: rgba(6, 182, 212, 0.3);
        color: @accent-cyan;
        display: flex;
        align-items: center;
        gap: 4px;

        i {
          font-size: 12px;
          transition: transform 0.3s;
        }

        &:hover {
          background: rgba(6, 182, 212, 0.15);

          i {
            transform: translateY(2px);
          }
        }

        &.active {
          background: rgba(6, 182, 212, 0.2);

          i {
            transform: rotate(180deg);
          }
        }
      }
    }
  }
}

.models-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
  position: relative;
  z-index: 2;
}

.model-card {
  background: @bg-secondary;
  border: 1px solid @border-color;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  animation: fade-up 0.5s ease backwards;
  animation-delay: var(--delay);

  @keyframes fade-up {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
  }

  &:hover {
    transform: translateY(-8px);
    border-color: rgba(6, 182, 212, 0.3);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);

    .card-shimmer {
      transform: translateX(100%);
    }

    .model-img {
      transform: scale(1.1);
    }

    .model-overlay {
      opacity: 1;
    }
  }

  .card-shimmer {
    position: absolute;
    top: 0;
    left: -100%;
    width: 50%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
    transform: skewX(-25deg);
    transition: transform 0.6s;
    z-index: 10;
    pointer-events: none;
  }

  .model-img-container {
    position: relative;
    aspect-ratio: 4/3;
    overflow: hidden;

    .model-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.5s;
    }

    .model-overlay {
      position: absolute;
      inset: 0;
      background: rgba(0, 0, 0, 0.6);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.3s;

      .view-btn {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 12px 24px;
        background: rgba(6, 182, 212, 0.2);
        border: 1px solid @accent-cyan;
        border-radius: 50px;
        color: #fff;
        font-size: 14px;
        backdrop-filter: blur(10px);
      }
    }

    .model-badge {
      position: absolute;
      top: 12px;
      right: 12px;
      padding: 4px 10px;
      border-radius: 4px;
      font-size: 11px;
      font-weight: 600;

      &.exclusive {
        background: linear-gradient(135deg, #f59e0b, #ef4444);
        color: #fff;
      }

      &.format {
        background: rgba(0, 0, 0, 0.6);
        color: @text-secondary;
        border: 1px solid @border-color;
      }

      // 新增：官方认证标签样式（左上角，金色风格与官方推荐区一致）
      &.official {
        left: 12px; // 左上角
        right: auto;
        background: rgba(245, 158, 11, 0.9); // 金色背景
        border-radius: 50px; // 圆角与官方推荐区一致
        color: #fff;
        display: flex;
        align-items: center;
        gap: 4px;
        backdrop-filter: blur(10px);
        box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3);

        i {
          font-size: 10px;
        }
      }

      &.invoice {
        background: linear-gradient(135deg, #e53935, #7c3aed);
        color: #fff;
        border-radius: 50px;
      }
    }
  }

  .model-info {
    padding: 20px;

    .model-name {
      font-size: 15px;
      font-weight: 600;
      color: @text-primary;
      margin-bottom: 12px;
      line-height: 1.4;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .model-meta {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .price {
        .amount {
          font-size: 20px;
          font-weight: 700;
          color: @accent-cyan;
        }

        .unit {
          font-size: 12px;
          color: @text-muted;
          margin-left: 4px;
        }
      }

      .sales {
        font-size: 13px;
        color: @text-muted;

        i {
          margin-right: 4px;
        }
      }
    }
  }

  &.skeleton {
    pointer-events: none;

    .skeleton-img {
      width: 100%;
      aspect-ratio: 4/3;
      background: linear-gradient(90deg, rgba(255, 255, 255, 0.05) 25%, rgba(255, 255, 255, 0.1) 50%, rgba(255, 255, 255, 0.05) 75%);
      background-size: 200% 100%;
      animation: skeleton-loading 1.5s infinite;
    }

    .skeleton-body {
      padding: 20px;

      .skeleton-line {
        height: 16px;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 4px;
        margin-bottom: 8px;

        &.short {
          width: 60%;
        }
      }
    }
  }
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

// ========== 新增：官方模型推荐模块 - 高级样式 ==========
.official-models-section {
  background: linear-gradient(135deg, #0a0e17 0%, #0f172a 50%, #0a0e17 100%);
  padding: 120px 0;
  position: relative;
  overflow: hidden;
  border-top: 1px solid rgba(6, 182, 212, 0.1);
  border-bottom: 1px solid rgba(6, 182, 212, 0.1);

  .official-bg-effects {
    position: absolute;
    inset: 0;
    overflow: hidden;

    .gradient-orb {
      position: absolute;
      border-radius: 50%;
      filter: blur(100px);
      opacity: 0.15;
      animation: orb-float 20s ease-in-out infinite;

      &.orb-1 {
        width: 600px;
        height: 600px;
        background: @accent-cyan;
        top: -200px;
        left: -100px;
        animation-delay: 0s;
      }

      &.orb-2 {
        width: 500px;
        height: 500px;
        background: @accent-indigo;
        bottom: -150px;
        right: -100px;
        animation-delay: -5s;
      }

      &.orb-3 {
        width: 400px;
        height: 400px;
        background: @accent-gold;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        opacity: 0.05;
        animation-delay: -10s;
      }
    }

    .mesh-grid {
      position: absolute;
      inset: 0;
      background-image:
        linear-gradient(rgba(6, 182, 212, 0.03) 1px, transparent 1px),
        linear-gradient(90deg, rgba(6, 182, 212, 0.03) 1px, transparent 1px);
      background-size: 100px 100px;
      mask-image: radial-gradient(circle at center, black 30%, transparent 80%);
    }
  }

  .official-header {
    text-align: center;
    margin-bottom: 60px;

    .official-badge {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 8px 20px;
      background: linear-gradient(135deg, rgba(245, 158, 11, 0.1), rgba(245, 158, 11, 0.05));
      border: 1px solid rgba(245, 158, 11, 0.3);
      border-radius: 50px;
      color: @accent-gold;
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 2px;
      margin-bottom: 20px;

      i {
        font-size: 16px;
      }
    }

    .section-title {
      font-size: 42px;
      font-weight: 800;
      background: linear-gradient(to right, #fff, @accent-gold, #fff);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-size: 200% auto;
      animation: shine 4s linear infinite;
    }

    .section-desc {
      font-size: 16px;
      color: @text-secondary;
      margin-top: 16px;
    }
  }

  // 特色展示位
  .featured-official-model {
    margin-bottom: 48px;

    .featured-card {
      display: grid;
      grid-template-columns: 1.2fr 1fr;
      gap: 0;
      background: rgba(255, 255, 255, 0.02);
      border: 1px solid rgba(255, 255, 255, 0.08);
      border-radius: 24px;
      overflow: hidden;
      cursor: pointer;
      position: relative;
      transition: all 0.4s;

      &:hover {
        border-color: rgba(6, 182, 212, 0.3);
        box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5), 0 0 30px rgba(6, 182, 212, 0.1);
        transform: translateY(-4px);

        .featured-image {
          transform: scale(1.05);
        }

        .featured-glow {
          opacity: 1;
        }
      }

      .featured-glow {
        position: absolute;
        inset: -1px;
        background: linear-gradient(135deg, rgba(6, 182, 212, 0.2), transparent 50%, rgba(245, 158, 11, 0.1));
        opacity: 0;
        transition: opacity 0.4s;
        pointer-events: none;
        z-index: 1;
      }

      .featured-image-wrap {
        position: relative;
        overflow: hidden;
        aspect-ratio: 16/10;

        .featured-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s;
        }

        .featured-overlay {
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.4);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.3s;

          .play-btn {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 16px 32px;
            background: rgba(6, 182, 212, 0.9);
            border-radius: 50px;
            color: #fff;
            font-size: 16px;
            font-weight: 600;
            backdrop-filter: blur(10px);
            transform: scale(0.9);
            transition: transform 0.3s;

            i {
              font-size: 24px;
            }
          }
        }

        &:hover .featured-overlay {
          opacity: 1;

          .play-btn {
            transform: scale(1);
          }
        }

        .official-tag {
          position: absolute;
          top: 24px;
          left: 24px;
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 10px 20px;
          background: rgba(245, 158, 11, 0.9);
          border-radius: 50px;
          color: #fff;
          font-size: 14px;
          font-weight: 600;
          backdrop-filter: blur(10px);
          box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3);
          z-index: 2;

          i {
            font-size: 16px;
          }
        }
      }

      .featured-content {
        padding: 40px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .featured-header {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          margin-bottom: 20px;
          gap: 20px;

          .featured-title {
            font-size: 28px;
            font-weight: 700;
            color: @text-primary;
            line-height: 1.3;
            flex: 1;
          }

          .featured-price {
            display: flex;
            align-items: baseline;
            gap: 4px;
            color: @accent-cyan;
            flex-shrink: 0;

            .price-icon {
              font-size: 20px;
              font-weight: 600;
            }

            .price-num {
              font-size: 32px;
              font-weight: 800;
            }
          }
        }

        .featured-desc {
          font-size: 15px;
          color: @text-secondary;
          line-height: 1.8;
          margin-bottom: 24px;

          // 新增：限制显示行数，超出显示省略号
          display: -webkit-box;
          -webkit-line-clamp: 3; // 可根据需要调整为 2 或 4
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .featured-meta {
          display: flex;
          gap: 24px;
          margin-bottom: 24px;
          padding-bottom: 24px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.08);

          .meta-item {
            display: flex;
            align-items: center;
            gap: 8px;
            color: @text-muted;
            font-size: 14px;

            i {
              color: @accent-cyan;
              font-size: 16px;
            }
          }
        }

        .featured-tags {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;

          .tag {
            padding: 6px 14px;
            background: rgba(6, 182, 212, 0.08);
            border: 1px solid rgba(6, 182, 212, 0.2);
            border-radius: 20px;
            color: @accent-cyan;
            font-size: 13px;
            font-weight: 500;
          }
        }
      }
    }
  }

  // 官方模型列表
  .official-models-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    margin-bottom: 48px;

    @media (max-width: 1024px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 640px) {
      grid-template-columns: 1fr;
    }

    .official-model-card {
      background: rgba(255, 255, 255, 0.02);
      border: 1px solid rgba(255, 255, 255, 0.06);
      border-radius: 20px;
      overflow: hidden;
      cursor: pointer;
      position: relative;
      transition: all 0.4s;
      animation: fade-up 0.5s ease backwards;
      animation-delay: var(--delay);

      &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(135deg, rgba(6, 182, 212, 0.1), transparent);
        opacity: 0;
        transition: opacity 0.4s;
        z-index: 0;
      }

      &:hover {
        transform: translateY(-8px);
        border-color: rgba(6, 182, 212, 0.3);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);

        &::before {
          opacity: 1;
        }

        .card-image {
          .image-shine {
            transform: translateX(100%) rotate(45deg);
          }
        }

        .official-card-border {
          opacity: 1;
        }
      }

      .official-card-border {
        position: absolute;
        inset: 0;
        border-radius: 20px;
        padding: 1px;
        background: linear-gradient(135deg, rgba(6, 182, 212, 0.5), rgba(245, 158, 11, 0.3), rgba(6, 182, 212, 0.5));
        -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        opacity: 0;
        transition: opacity 0.4s;
        pointer-events: none;
      }

      .card-glass-effect {
        position: absolute;
        inset: 0;
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.05), transparent);
        opacity: 0.3;
        pointer-events: none;
      }

      .card-image {
        position: relative;
        aspect-ratio: 4/3;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .image-shine {
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
          transform: translateX(-100%) rotate(45deg);
          transition: transform 0.6s;
          pointer-events: none;
        }

        .official-stamp {
          position: absolute;
          top: 12px;
          right: 12px;
          width: 36px;
          height: 36px;
          background: linear-gradient(135deg, @accent-gold, #f97316);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 18px;
          box-shadow: 0 4px 15px rgba(245, 158, 11, 0.4);
          z-index: 2;
        }
      }

      .card-content {
        padding: 20px;
        position: relative;
        z-index: 1;

        .card-title {
          font-size: 16px;
          font-weight: 600;
          color: @text-primary;
          margin-bottom: 12px;
          line-height: 1.4;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .card-stats {
          display: flex;
          gap: 16px;
          margin-bottom: 16px;
          font-size: 13px;
          color: @text-muted;

          .stat {
            display: flex;
            align-items: center;
            gap: 4px;

            i {
              color: @accent-gold;
              font-size: 14px;
            }
          }
        }

        .card-footer {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .card-price {
            font-size: 20px;
            font-weight: 700;
            color: @accent-cyan;
          }

          .card-action {
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 8px 16px;
            background: rgba(6, 182, 212, 0.1);
            border: 1px solid rgba(6, 182, 212, 0.3);
            border-radius: 20px;
            color: @accent-cyan;
            font-size: 13px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
              background: rgba(6, 182, 212, 0.2);
              transform: translateX(2px);
            }

            i {
              font-size: 12px;
              transition: transform 0.3s;
            }

            &:hover i {
              transform: translateX(2px);
            }
          }
        }
      }
    }
  }

  .official-footer {
    text-align: center;
  }

  .btn-premium-outline {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 16px 40px;
    background: transparent;
    border: 2px solid rgba(6, 182, 212, 0.3);
    border-radius: 50px;
    color: @accent-cyan;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(135deg, rgba(6, 182, 212, 0.1), rgba(59, 130, 246, 0.1));
      opacity: 0;
      transition: opacity 0.3s;
    }

    &:hover {
      border-color: @accent-cyan;
      transform: translateY(-2px);
      box-shadow: 0 10px 30px rgba(6, 182, 212, 0.2);

      &::before {
        opacity: 1;
      }

      i {
        transform: translateX(4px);
      }
    }

    span,
    i {
      position: relative;
      z-index: 1;
    }

    i {
      transition: transform 0.3s;
    }
  }
}

// ========== 模型师区（样式保持不变） ==========
.designers-section {
  background: @bg-primary;
  padding: 100px 0;
  position: relative;
  overflow: hidden;

  .diagonal-lines {
    position: absolute;
    inset: 0;
    overflow: hidden;
    opacity: 0.05;
    pointer-events: none; // 添加：允许点击穿透

    .d-line {
      position: absolute;
      width: 1px;
      height: 200%;
      background: linear-gradient(to bottom, transparent, @accent-cyan, transparent);
      transform: rotate(45deg);
      animation: diagonal-slide 15s linear infinite;

      &:nth-child(1) {
        left: 10%;
        animation-delay: 0s;
      }

      &:nth-child(2) {
        left: 20%;
        animation-delay: 2s;
      }

      &:nth-child(3) {
        left: 30%;
        animation-delay: 4s;
      }

      &:nth-child(4) {
        left: 50%;
        animation-delay: 1s;
      }

      &:nth-child(5) {
        left: 70%;
        animation-delay: 3s;
      }

      &:nth-child(6) {
        left: 80%;
        animation-delay: 5s;
      }

      &:nth-child(7) {
        left: 40%;
        animation-delay: 7s;
      }

      &:nth-child(8) {
        left: 60%;
        animation-delay: 6s;
      }

      &:nth-child(9) {
        left: 90%;
        animation-delay: 8s;
      }

      &:nth-child(10) {
        left: 15%;
        animation-delay: 9s;
      }
    }
  }

  @keyframes diagonal-slide {
    0% {
      transform: rotate(45deg) translateY(-100%);
    }

    100% {
      transform: rotate(45deg) translateY(100%);
    }
  }

  .hexagon-pattern {
    position: absolute;
    inset: 0;
    opacity: 0.03;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='49' viewBox='0 0 28 49'%3E%3Cg fill-rule='evenodd'%3E%3Cg id='hexagons' fill='%2306b6d4' fill-opacity='1' fill-rule='nonzero'%3E%3Cpath d='M13.99 9.25l13 7.5v15l-13 7.5L1 31.75v-15l12.99-7.5zM3 17.9v12.7l10.99 6.34 11-6.35V17.9l-11-6.34L3 17.9zM0 15l12.98-7.5V0h-2v6.35L0 12.69v2.3zm0 18.5L12.98 41v8h-2v-6.85L0 35.81v-2.3zM15 0v7.5L27.99 15H28v-2.31h-.01L17 6.35V0h-2zm0 49v-8l12.99-7.5H28v2.31h-.01L17 42.15V49h-2z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    animation: hexagon-drift 60s linear infinite;
    pointer-events: none; // 添加：允许点击穿透
  }

  @keyframes hexagon-drift {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(-50px);
    }
  }

  .section-bg-pattern {
    position: absolute;
    inset: 0;
    opacity: 0.02;
    background-image: radial-gradient(circle at 2px 2px, rgba(255, 255, 255, 0.8) 1px, transparent 0);
    background-size: 40px 40px;
    pointer-events: none; // 添加：允许点击穿透
  }
}

.designers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
  position: relative;
  z-index: 2;
}

.designer-card {
  background: rgba(31, 41, 55, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 24px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  animation: fade-up 0.5s ease backwards;
  animation-delay: var(--delay);
  backdrop-filter: blur(12px);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at 50% 0%, rgba(6, 182, 212, 0.15), transparent 70%);
    opacity: 0;
    transition: opacity 0.4s;
    pointer-events: none;
  }

  .card-border-glow {
    position: absolute;
    inset: -1px;
    border-radius: 20px;
    padding: 1px;
    background: linear-gradient(135deg, rgba(6, 182, 212, 0), rgba(6, 182, 212, 0.3), rgba(59, 130, 246, 0));
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    opacity: 0;
    transition: opacity 0.4s;
  }

  &:hover {
    transform: translateY(-8px);
    border-color: rgba(6, 182, 212, 0.3);
    box-shadow:
      0 20px 40px rgba(0, 0, 0, 0.4),
      0 0 30px rgba(6, 182, 212, 0.15),
      inset 0 1px 0 rgba(255, 255, 255, 0.1);

    &::before {
      opacity: 1;
    }

    .card-border-glow {
      opacity: 1;
    }

    .avatar {
      transform: scale(1.08);
      border-color: @accent-cyan;
      box-shadow: 0 0 20px rgba(6, 182, 212, 0.3);
    }

    .avatar-glow {
      opacity: 1;
    }

    .designer-header .header-info .name {
      color: @accent-light;
    }
  }

  .designer-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
    position: relative;
    z-index: 2;

    .avatar-wrap {
      position: relative;
      flex-shrink: 0;

      .avatar-glow {
        position: absolute;
        inset: -4px;
        border-radius: 50%;
        background: radial-gradient(circle, rgba(6, 182, 212, 0.3) 0%, transparent 70%);
        opacity: 0;
        transition: opacity 0.3s;
        filter: blur(8px);

        &.online {
          opacity: 0.6;
          background: radial-gradient(circle, rgba(16, 185, 129, 0.3) 0%, transparent 70%);
        }
      }

      .avatar {
        width: 64px;
        height: 64px;
        border-radius: 10%;
        object-fit: cover;
        border: 2px solid rgba(255, 255, 255, 0.1);
        transition: all 0.3s;
        position: relative;
        z-index: 2;
      }

      .status-indicator {
        position: absolute;
        bottom: 2px;
        right: 2px;
        width: 14px;
        height: 14px;
        background: #10b981;
        border-radius: 50%;
        border: 2px solid @bg-secondary;
        z-index: 3;
        display: flex;
        align-items: center;
        justify-content: center;

        .pulse {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: #10b981;
          animation: status-pulse 2s ease-in-out infinite;
        }
      }
    }

    @keyframes status-pulse {

      0%,
      100% {
        transform: scale(1);
        opacity: 1;
      }

      50% {
        transform: scale(1.5);
        opacity: 0.5;
      }
    }

    .header-info {
      flex: 1;
      min-width: 0;

      .name {
        font-size: 18px;
        font-weight: 700;
        color: @text-primary;
        margin-bottom: 4px;
        transition: color 0.3s;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .title {
        font-size: 13px;
        color: @text-muted;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .designer-stats {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
    padding: 16px;
    background: rgba(255, 255, 255, 0.03);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.05);
    position: relative;
    z-index: 2;

    .stat {
      flex: 1;
      text-align: center;
      position: relative;

      &:not(:last-child)::after {
        content: '';
        position: absolute;
        right: -6px;
        top: 50%;
        transform: translateY(-50%);
        height: 24px;
        width: 1px;
        background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.1), transparent);
      }

      .num {
        display: block;
        font-size: 18px;
        font-weight: 700;
        color: @accent-cyan;
        margin-bottom: 2px;
        transition: transform 0.3s;
      }

      .label {
        font-size: 12px;
        color: @text-muted;
      }

      &:hover .num {
        transform: scale(1.1);
      }
    }
  }

  .follow-btn {
    width: 100%;
    padding: 12px;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    color: @text-secondary;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.3s;
    position: relative;
    overflow: hidden;
    z-index: 2;

    .btn-bg {
      position: absolute;
      inset: 0;
      background: linear-gradient(135deg, rgba(6, 182, 212, 0), rgba(59, 130, 246, 0));
      opacity: 0;
      transition: all 0.3s;
    }

    .btn-shine {
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
      transition: left 0.5s;
    }

    &:hover {
      border-color: @accent-cyan;
      color: @accent-cyan;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(6, 182, 212, 0.15);

      .btn-bg {
        background: linear-gradient(135deg, rgba(6, 182, 212, 0.1), rgba(59, 130, 246, 0.05));
        opacity: 1;
      }

      .btn-shine {
        left: 100%;
      }
    }

    &.followed {
      background: rgba(6, 182, 212, 0.15);
      border-color: @accent-cyan;
      color: @accent-cyan;

      &:hover {
        background: rgba(6, 182, 212, 0.25);
        box-shadow: 0 4px 12px rgba(6, 182, 212, 0.25);
      }
    }

    i {
      font-size: 14px;
      transition: transform 0.3s;
    }

    &:active {
      transform: scale(0.98);
    }
  }

  &.skeleton {
    pointer-events: none;

    .skeleton-avatar {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      background: linear-gradient(90deg, rgba(255, 255, 255, 0.05) 25%, rgba(255, 255, 255, 0.1) 50%, rgba(255, 255, 255, 0.05) 75%);
      background-size: 200% 100%;
      animation: skeleton-loading 1.5s infinite;
      flex-shrink: 0;
    }

    .skeleton-body {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 8px;

      .skeleton-line {
        height: 16px;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 4px;

        &.short {
          width: 60%;
        }
      }
    }
  }
}

// ========== 分类区 - 螺旋分布防重叠气泡（已移动位置） ==========
.category-cloud-section {
  background: @bg-primary;
  padding: 100px 0 120px;
  position: relative;
  overflow: visible;

  .section-bg-effects {
    position: absolute;
    inset: 0;
    pointer-events: none;
    overflow: hidden;

    .glow-orb {
      position: absolute;
      width: 600px;
      height: 600px;
      border-radius: 50%;
      filter: blur(120px);
      opacity: 0.12;

      &.left {
        background: @accent-cyan;
        top: -200px;
        left: -200px;
      }

      &.right {
        background: @accent-blue;
        bottom: -200px;
        right: -200px;
      }
    }

    .floating-dots {
      position: absolute;
      inset: 0;

      .dot {
        position: absolute;
        background: rgba(6, 182, 212, 0.3);
        border-radius: 50%;
        animation: dot-pulse 4s ease-in-out infinite;

        &::before {
          content: '';
          position: absolute;
          inset: -2px;
          border-radius: 50%;
          border: 1px solid rgba(6, 182, 212, 0.1);
          animation: dot-ripple 3s linear infinite;
        }
      }
    }
  }

  @keyframes dot-pulse {

    0%,
    100% {
      opacity: 0.2;
      transform: scale(1);
    }

    50% {
      opacity: 0.6;
      transform: scale(1.2);
    }
  }

  @keyframes dot-ripple {
    0% {
      transform: scale(1);
      opacity: 1;
    }

    100% {
      transform: scale(3);
      opacity: 0;
    }
  }
}

.section-header {
  margin-bottom: 60px;
  position: relative;
  z-index: 10;

  .section-label {
    display: block;
    font-size: 12px;
    letter-spacing: 4px;
    color: @accent-cyan;
    margin-bottom: 12px;
    font-weight: 600;
  }

  .section-title {
    font-size: 36px;
    font-weight: 700;
    color: @text-primary;
    background: linear-gradient(to right, #fff, @accent-light, #fff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-size: 200% auto;
    animation: shine 3s linear infinite;
    letter-spacing: -1px;
  }

  &.split {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    text-align: left;

    .title-tabs {
      display: flex;
      gap: 12px;

      .tab-btn {
        padding: 10px 24px;
        background: transparent;
        border: 1px solid @border-color;
        border-radius: 50px;
        color: @text-secondary;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          border-color: @text-muted;
          color: @text-primary;
        }

        &.active {
          background: rgba(6, 182, 212, 0.1);
          border-color: @accent-cyan;
          color: @accent-cyan;
        }
      }
    }
  }
}

.category-cloud-container {
  position: relative;
  height: 720px;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  perspective: 1000px;
}

// 中央信息枢纽
.center-info-hub {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 160px;
  height: 160px;
  z-index: 80;

  .hub-ring {
    position: absolute;
    border-radius: 50%;
    border: 1px solid rgba(6, 182, 212, 0.2);

    &.outer {
      inset: -25px;
      border-style: dashed;
      border-width: 2px;
      animation: rotate 25s linear infinite;
    }

    &.inner {
      inset: -12px;
      border-style: solid;
      animation: rotate 18s linear infinite reverse;
    }

    &.scan {
      inset: -35px;
      border: 1px solid transparent;
      border-top: 2px solid rgba(6, 182, 212, 0.6);
      animation: scan-rotate 8s linear infinite;
      box-shadow: 0 0 10px rgba(6, 182, 212, 0.3);
    }
  }

  .hub-glow {
    position: absolute;
    inset: -40px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(6, 182, 212, 0.15) 0%, transparent 70%);
    animation: pulse-glow 4s ease-in-out infinite;
  }

  .hub-content {
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at 30% 30%, rgba(6, 182, 212, 0.25), rgba(6, 182, 212, 0.08));
    border: 2px solid rgba(6, 182, 212, 0.4);
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(12px);
    box-shadow:
      inset 0 0 30px rgba(6, 182, 212, 0.2),
      0 0 40px rgba(6, 182, 212, 0.2);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

    .hub-number {
      font-size: 28px;
      font-weight: 800;
      color: #fff;
      line-height: 1;
      text-shadow: 0 0 20px rgba(6, 182, 212, 0.5);
      transition: all 0.3s;
      white-space: nowrap;
    }

    .hub-label {
      font-size: 13px;
      color: @text-secondary;
      margin-top: 6px;
      transition: all 0.3s;
      letter-spacing: 1px;
    }
  }

  &.active {
    .hub-content {
      background: radial-gradient(circle at 30% 30%, rgba(6, 182, 212, 0.35), rgba(6, 182, 212, 0.12));
      border-color: @accent-light;
      box-shadow:
        inset 0 0 40px rgba(6, 182, 212, 0.3),
        0 0 60px rgba(6, 182, 212, 0.4),
        0 0 100px rgba(6, 182, 212, 0.2);
      transform: scale(1.05);
    }

    .hub-number {
      color: @accent-light;
      transform: scale(1.1);
      text-shadow: 0 0 30px rgba(103, 232, 249, 0.8);
    }

    .hub-label {
      color: #fff;
    }
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes scan-rotate {
  0% {
    transform: rotate(0deg);
    opacity: 0.3;
  }

  50% {
    opacity: 1;
  }

  100% {
    transform: rotate(360deg);
    opacity: 0.3;
  }
}

@keyframes pulse-glow {

  0%,
  100% {
    transform: scale(1);
    opacity: 0.4;
  }

  50% {
    transform: scale(1.2);
    opacity: 0.7;
  }
}

// 分层气泡样式
.category-bubble {
  position: absolute;
  cursor: pointer;
  z-index: 5;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.4s, border-color 0.4s;
  border-radius: 50%;
  aspect-ratio: 1/1;

  animation: bubble-drift var(--float-duration, 8s) ease-in-out var(--float-delay, 0s) infinite;
  will-change: transform;

  &.inner-layer {
    .bubble-bg {
      background: radial-gradient(circle at 30% 30%,
          rgba(103, 232, 249, 0.35),
          rgba(6, 182, 212, 0.25) 50%,
          rgba(6, 182, 212, 0.1) 100%);
      border: 1px solid rgba(103, 232, 249, 0.4);
      box-shadow:
        0 4px 20px rgba(6, 182, 212, 0.2),
        inset 0 0 20px rgba(103, 232, 249, 0.1);
    }

    .bubble-content {
      i {
        color: #a5f3fc;
      }

      .bubble-count {
        color: #67e8f9;
      }
    }
  }

  &.mid-layer {
    .bubble-bg {
      background: radial-gradient(circle at 30% 30%,
          rgba(59, 130, 246, 0.3),
          rgba(6, 182, 212, 0.18) 50%,
          rgba(15, 23, 42, 0.1) 100%);
      border: 1px solid rgba(59, 130, 246, 0.35);
      box-shadow:
        0 4px 15px rgba(59, 130, 246, 0.15),
        inset 0 0 15px rgba(59, 130, 246, 0.05);
    }

    .bubble-content {
      i {
        color: #60a5fa;
      }

      .bubble-count {
        color: #38bdf8;
      }
    }
  }

  &.outer-layer {
    .bubble-bg {
      background: radial-gradient(circle at 30% 30%,
          rgba(99, 102, 241, 0.2),
          rgba(59, 130, 246, 0.12) 50%,
          rgba(15, 23, 42, 0.15) 100%);
      border: 1px solid rgba(99, 102, 241, 0.25);
      box-shadow:
        0 4px 10px rgba(99, 102, 241, 0.1),
        inset 0 0 10px rgba(99, 102, 241, 0.05);
    }

    .bubble-content {
      i {
        color: #818cf8;
      }

      .bubble-count {
        color: #a5b4fc;
      }
    }

    opacity: 0.9;
  }

  &:hover,
  &.active {
    z-index: 100 !important;
    animation-play-state: paused !important;
    transform: scale(1.15) !important;
    opacity: 1;

    .bubble-bg {
      background: radial-gradient(circle at 30% 30%,
          rgba(103, 232, 249, 0.5),
          rgba(6, 182, 212, 0.35) 50%,
          rgba(6, 182, 212, 0.2) 100%);
      border: 1px solid rgba(103, 232, 249, 0.6);
      box-shadow:
        0 0 40px rgba(103, 232, 249, 0.3),
        0 0 80px rgba(6, 182, 212, 0.2),
        inset 0 0 30px rgba(255, 255, 255, 0.2);
    }

    .bubble-shine {
      opacity: 0.9;
      transform: scale(1.3) rotate(45deg);
    }

    .bubble-content {
      transform: scale(1.05);

      i {
        color: #fff;
        transform: scale(1.2);
        filter: drop-shadow(0 0 10px rgba(103, 232, 249, 1));
      }

      .bubble-name {
        color: #fff;
        font-weight: 700;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
      }

      .bubble-count {
        color: rgba(255, 255, 255, 0.95);
        font-weight: 600;
      }
    }
  }

  .bubble-bg {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    backdrop-filter: blur(12px);
    transition: all 0.4s;
    overflow: hidden;

    .bubble-shine {
      position: absolute;
      top: 15%;
      left: 15%;
      width: 35%;
      height: 35%;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.8) 0%, transparent 70%);
      border-radius: 50%;
      opacity: 0.4;
      transition: all 0.4s;
      pointer-events: none;
    }
  }

  .bubble-content {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    text-align: center;
    transition: all 0.4s;
    pointer-events: none;
    padding: 16px;

    i {
      font-size: 24px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.4s;
      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
      margin-bottom: 2px;
    }

    .bubble-name {
      font-size: 14px;
      font-weight: 600;
      color: @text-primary;
      line-height: 1.2;
      max-width: 90%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
      transition: all 0.4s;
    }

    .bubble-count {
      font-size: 12px;
      opacity: 0.9;
      transition: all 0.4s;
      font-weight: 500;
    }
  }
}

@keyframes bubble-drift {

  0%,
  100% {
    transform: translate3d(0, 0, 0) scale(1);
  }

  20% {
    transform: translate3d(calc(var(--drift-range-x) * 0.5), calc(var(--drift-range) * -0.3), 0) scale(1.02);
  }

  40% {
    transform: translate3d(calc(var(--drift-range-x) * -0.3), calc(var(--drift-range) * 0.6), 0) scale(1);
  }

  60% {
    transform: translate3d(calc(var(--drift-range-x) * -0.6), calc(var(--drift-range) * -0.2), 0) scale(1.01);
  }

  80% {
    transform: translate3d(calc(var(--drift-range-x) * 0.2), calc(var(--drift-range) * 0.4), 0) scale(1.02);
  }
}

// ========== 招募区（样式保持不变） ==========
.recruit-section {
  background: linear-gradient(180deg, @bg-secondary 0%, @bg-primary 100%);
  padding: 120px 0;
  position: relative;
  overflow: hidden;

  .bg-effects {
    position: absolute;
    inset: 0;
    overflow: hidden;

    .aurora-bg {
      position: absolute;
      inset: 0;
      background:
        radial-gradient(ellipse at 20% 50%, rgba(6, 182, 212, 0.08) 0%, transparent 50%),
        radial-gradient(ellipse at 80% 50%, rgba(59, 130, 246, 0.08) 0%, transparent 50%);
      filter: blur(60px);
      animation: aurora-flow 10s ease-in-out infinite alternate;
    }

    @keyframes aurora-flow {
      0% {
        transform: translateX(-10%) rotate(0deg);
        opacity: 0.3;
      }

      100% {
        transform: translateX(10%) rotate(5deg);
        opacity: 0.5;
      }
    }

    .grid-overlay {
      position: absolute;
      inset: 0;
      background-image:
        linear-gradient(rgba(6, 182, 212, 0.03) 1px, transparent 1px),
        linear-gradient(90deg, rgba(6, 182, 212, 0.03) 1px, transparent 1px);
      background-size: 80px 80px;
      mask-image: radial-gradient(circle at center, black 40%, transparent 100%);
    }

    .glow-orb {
      position: absolute;
      width: 500px;
      height: 500px;
      border-radius: 50%;
      filter: blur(100px);
      opacity: 0.15;

      &.left {
        background: @accent-cyan;
        top: -150px;
        left: -150px;
        animation: orb-float 8s ease-in-out infinite;
      }

      &.right {
        background: @accent-blue;
        bottom: -150px;
        right: -150px;
        animation: orb-float 8s ease-in-out infinite reverse;
      }
    }

    @keyframes orb-float {

      0%,
      100% {
        transform: translate(0, 0);
      }

      50% {
        transform: translate(30px, -30px);
      }
    }
  }
}

.recruit-layout {
  display: grid;
  grid-template-columns: 1fr 480px;
  gap: 100px;
  align-items: center;
  position: relative;
  z-index: 2;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 60px;
  }
}

.recruit-main {
  .recruit-header {
    margin-bottom: 32px;

    .recruit-label {
      display: block;
      font-size: 13px;
      letter-spacing: 4px;
      color: @accent-cyan;
      margin-bottom: 16px;
      font-weight: 600;
    }

    .recruit-title {
      font-size: 48px;
      font-weight: 800;
      color: @text-primary;
      line-height: 1.2;
      margin-bottom: 20px;

      .highlight {
        background: linear-gradient(to right, @accent-cyan, @accent-blue);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }

  .recruit-desc {
    font-size: 18px;
    color: @text-secondary;
    line-height: 1.8;
    margin-bottom: 40px;
  }

  .benefits {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .benefit-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 20px 24px;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    transition: all 0.3s;

    &:hover {
      background: rgba(255, 255, 255, 0.05);
      transform: translateX(8px);
      border-color: rgba(6, 182, 212, 0.2);
    }

    .benefit-icon {
      width: 48px;
      height: 48px;
      background: rgba(6, 182, 212, 0.1);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @accent-cyan;
      font-size: 24px;
      flex-shrink: 0;
    }

    .benefit-content {
      flex: 1;

      strong {
        display: block;
        color: @text-primary;
        font-size: 16px;
        margin-bottom: 4px;
      }

      span {
        color: @text-muted;
        font-size: 14px;
      }
    }
  }
}

.recruit-action {
  .action-card-premium {
    position: relative;
    width: 100%;
    padding: 60px 48px;
    background: rgba(11, 18, 32, 0.8);
    border-radius: 28px;
    overflow: hidden;
    backdrop-filter: blur(20px);

    .card-glow {
      position: absolute;
      inset: -2px;
      background: linear-gradient(135deg, rgba(6, 182, 212, 0.3), rgba(59, 130, 246, 0.3), rgba(6, 182, 212, 0.3));
      border-radius: 28px;
      opacity: 0.3;
      filter: blur(20px);
      animation: glow-pulse 4s ease-in-out infinite;
    }

    @keyframes glow-pulse {

      0%,
      100% {
        opacity: 0.2;
        transform: scale(0.95);
      }

      50% {
        opacity: 0.4;
        transform: scale(1.05);
      }
    }

    .card-border {
      position: absolute;
      inset: 0;
      border-radius: 28px;
      padding: 2px;
      background: linear-gradient(135deg, rgba(6, 182, 212, 0.5), rgba(59, 130, 246, 0.3), rgba(6, 182, 212, 0.5));
      -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      animation: border-rotate 6s linear infinite;
    }

    @keyframes border-rotate {
      0% {
        filter: hue-rotate(0deg);
      }

      100% {
        filter: hue-rotate(360deg);
      }
    }

    .card-content {
      position: relative;
      z-index: 2;
      text-align: center;

      .icon-container {
        position: relative;
        width: 120px;
        height: 120px;
        margin: 0 auto 32px;
        display: flex;
        align-items: center;
        justify-content: center;

        .icon-ring {
          position: absolute;
          border-radius: 50%;
          border: 2px solid transparent;

          &.outer {
            inset: 0;
            border-top-color: rgba(6, 182, 212, 0.4);
            border-right-color: rgba(6, 182, 212, 0.15);
            animation: ring-rotate 10s linear infinite;
          }

          &.inner {
            inset: 12px;
            border-bottom-color: rgba(59, 130, 246, 0.4);
            border-left-color: rgba(59, 130, 246, 0.15);
            animation: ring-rotate-reverse 8s linear infinite;
          }
        }

        @keyframes ring-rotate {
          from {
            transform: rotate(0deg);
          }

          to {
            transform: rotate(360deg);
          }
        }

        @keyframes ring-rotate-reverse {
          from {
            transform: rotate(360deg);
          }

          to {
            transform: rotate(0deg);
          }
        }

        .icon-glow {
          position: absolute;
          inset: 20px;
          background: radial-gradient(circle, rgba(6, 182, 212, 0.2) 0%, transparent 70%);
          border-radius: 50%;
          animation: icon-pulse 3s ease-in-out infinite;
        }

        @keyframes icon-pulse {

          0%,
          100% {
            transform: scale(1);
            opacity: 0.4;
          }

          50% {
            transform: scale(1.2);
            opacity: 0.6;
          }
        }

        .main-icon {
          font-size: 48px;
          color: #fff;
          filter: drop-shadow(0 0 15px rgba(6, 182, 212, 0.5));
          position: relative;
          z-index: 2;
        }
      }

      .card-title {
        font-size: 28px;
        font-weight: 700;
        color: @text-primary;
        margin-bottom: 12px;
        letter-spacing: -0.5px;
      }

      .card-subtitle {
        font-size: 16px;
        color: @text-secondary;
        margin-bottom: 24px;
      }

      .feature-tags {
        display: flex;
        justify-content: center;
        gap: 12px;
        margin-bottom: 32px;

        .tag {
          padding: 6px 16px;
          background: rgba(6, 182, 212, 0.08);
          border: 1px solid rgba(6, 182, 212, 0.2);
          border-radius: 20px;
          font-size: 13px;
          color: @accent-cyan;
          font-weight: 500;
        }
      }

      .btn-premium {
        position: relative;
        display: inline-flex;
        align-items: center;
        gap: 10px;
        padding: 18px 40px;
        background: linear-gradient(135deg, @accent-cyan, @accent-blue);
        border: none;
        border-radius: 50px;
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        overflow: hidden;
        transition: all 0.3s;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 30px rgba(6, 182, 212, 0.3);

          i {
            transform: translateX(4px);
          }

          .btn-glow {
            opacity: 1;
          }
        }

        i {
          transition: transform 0.3s;
        }

        .btn-glow {
          position: absolute;
          inset: -2px;
          background: linear-gradient(135deg, rgba(255, 255, 255, 0.3), transparent);
          border-radius: 50px;
          opacity: 0;
          transition: opacity 0.3s;
        }
      }
    }
  }
}

// 公共按钮样式
.btn-outline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 32px;
  background: transparent;
  border: 1px solid rgba(6, 182, 212, 0.5);
  border-radius: 50px;
  color: @accent-cyan;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: rgba(6, 182, 212, 0.1);
    border-color: @accent-cyan;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &.light {
    border-color: rgba(255, 255, 255, 0.2);
    color: @text-secondary;

    &:hover {
      border-color: @text-primary;
      color: @text-primary;
      background: rgba(255, 255, 255, 0.05);
    }
  }
}

.load-more {
  text-align: center;
  margin-top: 60px;
  position: relative; // 确保z-index生效
  z-index: 10; // 明确置于特效层之上
}

.no-data {
  text-align: center;
  padding: 80px 20px;
  color: @text-muted;

  i {
    font-size: 48px;
    margin-bottom: 16px;
    display: block;
    opacity: 0.5;
  }
}

// ========== 响应式适配 ==========
@media (max-width: 1024px) {
  .container {
    &.narrow {
      max-width: 100%;
      padding: 0 24px;
    }
  }

  .platform-title-wrapper {
    .platform-title {
      font-size: 44px;
    }
  }

  .category-cloud-container {
    height: 700px;
    transform: scale(0.9);
  }

  .models-grid {
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 20px;
  }

  .designers-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  .designer-card {
    padding: 20px;

    .designer-header {
      gap: 12px;

      .avatar-wrap {
        .avatar {
          width: 56px;
          height: 56px;
        }
      }

      .header-info {
        .name {
          font-size: 16px;
        }
      }
    }

    .designer-stats {
      padding: 12px;

      .stat {
        .num {
          font-size: 16px;
        }

        .label {
          font-size: 11px;
        }
      }
    }
  }

  .recruit-layout {
    grid-template-columns: 1fr;
    gap: 60px;

    .action-card-premium {
      max-width: 480px;
      margin: 0 auto;
    }
  }

  .banner {
    min-height: 700px;
  }

  .banner-desc .main-title {
    font-size: 44px;
  }

  // 官方模型区响应式
  .official-models-section {
    padding: 80px 0;

    .featured-official-model {
      .featured-card {
        grid-template-columns: 1fr;

        .featured-image-wrap {
          aspect-ratio: 16/9;
        }

        .featured-content {
          padding: 28px;
        }
      }
    }

    .official-models-list {
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
    }
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0 16px;

    &.narrow {
      padding: 0 16px;
    }
  }

  .platform-title-wrapper {
    .platform-badge {
      font-size: 11px;
      padding: 6px 14px;
    }

    .platform-title {
      font-size: 28px;
      letter-spacing: 2px;
    }

    .platform-subtitle {
      font-size: 14px;
      letter-spacing: 4px;
    }
  }

  .banner {
    min-height: 600px;
    margin-top: -50px;

    .banner-search-wrapper {
      width: 95%;
      margin-bottom: 40px;

      .banner-search-box {
        height: 56px;
        padding: 0 4px 0 16px;

        .banner-search-input {
          font-size: 14px;
        }

        .banner-search-btn {
          height: 48px;
          padding: 0 20px;
          font-size: 14px;

          span {
            display: none;
          }
        }
      }
    }
  }

  .banner-desc {
    padding: 0 20px;

    .main-title {
      font-size: 32px;
    }

    .sub-title {
      font-size: 16px;
    }

    .desc-stats {
      gap: 24px;
      flex-wrap: wrap;

      .stat-item {
        .stat-num {
          font-size: 24px;
        }
      }

      .stat-divider {
        display: none;
      }
    }
  }

  .category-cloud-container {
    height: 600px;
    transform: scale(0.75);
    margin: -40px auto;
  }

  .section-header {
    margin-bottom: 40px;

    .section-title {
      font-size: 28px;
    }

    &.split {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;

      .title-tabs {
        width: 100%;
        overflow-x: auto;
        padding-bottom: 8px;
        -webkit-overflow-scrolling: touch;

        &::-webkit-scrollbar {
          display: none;
        }

        .tab-btn {
          padding: 8px 16px;
          font-size: 13px;
          white-space: nowrap;
        }
      }
    }
  }

  // 官方模型区移动端适配
  .official-models-section {
    padding: 60px 0;

    .official-header {
      .section-title {
        font-size: 28px;
      }

      .section-desc {
        font-size: 14px;
      }
    }

    .featured-official-model {
      .featured-card {
        .featured-content {
          padding: 20px;

          .featured-header {
            flex-direction: column;
            gap: 12px;

            .featured-title {
              font-size: 20px;
            }

            .featured-price {
              .price-num {
                font-size: 24px;
              }
            }
          }

          .featured-meta {
            flex-wrap: wrap;
            gap: 12px;
          }
        }
      }
    }

    .official-models-list {
      grid-template-columns: 1fr;
      gap: 16px;
    }
  }

  .models-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 12px;

    .model-card {
      .model-img-container {
        aspect-ratio: 1/1;
      }

      .model-info {
        padding: 12px;

        .model-name {
          font-size: 13px;
          margin-bottom: 8px;
          -webkit-line-clamp: 1;
        }

        .model-meta {
          .price {
            .amount {
              font-size: 16px;
            }

            .unit {
              font-size: 11px;
            }
          }

          .sales {
            font-size: 11px;
          }
        }
      }

      .model-badge {
        padding: 2px 6px;
        font-size: 10px;
      }
    }
  }

  .designers-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 12px;

    .designer-card {
      padding: 16px;

      .designer-header {
        flex-direction: column;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;

        .avatar-wrap {
          .avatar {
            width: 52px;
            height: 52px;
          }
        }

        .header-info {
          text-align: center;
          width: 100%;

          .name {
            font-size: 14px;
            margin-bottom: 2px;
          }

          .title {
            font-size: 11px;
          }
        }
      }

      .designer-stats {
        padding: 10px;
        margin-bottom: 12px;
        gap: 8px;

        .stat {
          .num {
            font-size: 14px;
          }

          .label {
            font-size: 10px;
          }

          &:not(:last-child)::after {
            display: none;
          }
        }
      }

      .follow-btn {
        padding: 10px;
        font-size: 12px;
      }
    }
  }

  .quick-filters {
    gap: 8px;
    margin-bottom: 24px;
    overflow-x: auto;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 8px;
    margin-right: -16px;
    padding-right: 16px;

    &::-webkit-scrollbar {
      display: none;
    }

    .quick-tag {
      padding: 6px 12px;
      font-size: 12px;
      white-space: nowrap;
      flex-shrink: 0;
    }
  }

  .recruit-section {
    padding: 80px 0;

    .recruit-main {
      .recruit-header {
        .recruit-title {
          font-size: 32px;
        }
      }

      .recruit-desc {
        font-size: 15px;
      }

      .benefits {
        .benefit-item {
          padding: 16px;

          .benefit-icon {
            width: 40px;
            height: 40px;
            font-size: 20px;
          }

          .benefit-content {
            strong {
              font-size: 14px;
            }

            span {
              font-size: 12px;
            }
          }
        }
      }
    }
  }

  .action-card-premium {
    padding: 40px 24px !important;

    .card-content {
      .icon-container {
        width: 80px;
        height: 80px;
        margin-bottom: 20px;

        .main-icon {
          font-size: 32px;
        }
      }

      .card-title {
        font-size: 20px !important;
      }

      .card-subtitle {
        font-size: 13px !important;
      }

      .feature-tags {
        gap: 8px;
        margin-bottom: 20px;

        .tag {
          padding: 4px 12px;
          font-size: 11px;
        }
      }

      .btn-premium {
        padding: 14px 28px !important;
        font-size: 14px !important;
      }
    }
  }

  .load-more {
    margin-top: 40px;
  }

  .btn-outline {
    padding: 12px 24px;
    font-size: 13px;
  }
}

@media (max-width: 380px) {
  .platform-title-wrapper {
    .platform-title {
      font-size: 24px;
    }
  }

  .models-grid {
    gap: 8px;

    .model-card {
      .model-info {
        padding: 10px;

        .model-meta {
          flex-direction: column;
          align-items: flex-start;
          gap: 4px;
        }
      }
    }
  }

  .designers-grid {
    gap: 8px;

    .designer-card {
      padding: 12px;

      .follow-btn {
        padding: 8px;
      }
    }
  }

  .banner-desc {
    .main-title {
      font-size: 28px;
    }

    .desc-stats {
      .stat-item {
        .stat-num {
          font-size: 20px;
        }

        .stat-label {
          font-size: 11px;
        }
      }
    }
  }
}
</style>
<style>
/* 搜索高亮样式 - 必须放在非 scoped 样式中才能生效 */
.banner-search-dropdown .dropdown-item .search-highlight {
  color: #67e8f9 !important;
  font-weight: 700;
  background: rgba(6, 182, 212, 0.2);
  padding: 2px 6px;
  border-radius: 4px;
  text-shadow: 0 0 10px rgba(103, 232, 249, 0.8),
    0 0 20px rgba(6, 182, 212, 0.4);
  /* box-shadow: 0 0 8px rgba(6, 182, 212, 0.3); */
  margin: 0 2px;
}
</style>